// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1soj3","copyright":"Footer_copyright__HaMqn"};